var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMv0)",
    d: "M12 4.714a7.286 7.286 0 1 1 .358 14.567A7.286 7.286 0 0 1 12 4.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMv1)",
    d: "M12 5.143a6.857 6.857 0 1 1 0 13.714a6.857 6.857 0 0 1 0-13.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38FEFE",
    d: "m14.156 16.628l.022-.094c.042-.231.145-.673.394-.677c.171-.004.446.257.428.428c-.021.193-.317.33-.428.43c.086.663-.18.998-.78.98c-.189-.004-.27.065-.27.15c0 .155.137.245.27.245a1.7 1.7 0 0 0 1.136-.463c.304-.201.497-.63.501-1.054c0-.343-.12-.686-.377-.9c-.279-.236-.66-.223-1.067-.318c-.647-.145-.335-.964-.913-.93c-.214.013-.373.078-.386.266c-.043.566.814.523 1.114 1.192c.078.175.086.188.146.347c.082.158.086.291.21.398"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#48FC2E",
    d: "M15.725 8.554c-.163.377-.39.557-.489 1.016c-.043.476.099.66.257.947l.017-.36c-.051-1.071 1.059-1.311 1.813-1.187c.429.073.245.158.399-.017c-.326-.343-.514-.656-1.243-.686c-.017-.639-.223-1.029-.686-1.243c.116.532.33 1.012-.068 1.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMv2)",
    d: "M8.058 7.817c.128-.369.402-.87.587-1.26c-.326.167-1.145.789-1.269 1.037c-.377.729-.356.969-.39 1.873c-.008.334.06.343-.223.471l-.107-1.144c-.416.292-.291-.013-.548.6c-.322.754-.502 1.037-.005 1.68c.197.261.485.249.78.399c.185.42.227.891.6 1.26a.3.3 0 0 0 .035-.065l.064-.814l.103 1.012c.557-.42.308-1.11.591-1.32c.103-.078.03.03.236-.099c.171-.111.124-.154.257-.249c.33-.231.317.107.544-.441l.095-.082l.111-.12c.193-.274.15-.668.021-.9c-.102.125-.064.18-.124.348c-.008-.326-.094-.6-.441-.78l-.03.613l-.022.3c-.368-.335.03-1.068-.265-1.329c-.185-.231-.103-.231-.129-.317c-.026-.107 0-.086-.043-.232a2 2 0 0 0-.171-.317l-.27.557l.008-.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EFBF8",
    d: "M7.715 14.786c.021.33.27.651.527.642c.261-.008.531-.312.758-.428c-.197.377-.18.24-.098.763c.296-.159.518-.206.677-.493c.274-.502.257-.596.33-1.2c-.051-.133.129-.129-.206-.06c-.137.026-.163.077-.227.15c-.296.313 0 .188-.523.283c-.497.094-.617.557-.887.557c-.094 0-.206-.086-.351-.214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMv3)",
    d: "M16.62 10.388c-.025-.342-.081-.522.33-.505c.596.021.759.758.356 1.178c-.463.48-1.076.099-1.586.082c-.702-.026-1.148.214-1.148.882c0 .33.45.78.428 1.093c-.017.219-.111.322-.261.322a.27.27 0 0 1-.24-.129c-.129-.236.069-.201.193-.403c-.292-.085-.549-.038-.562.292c-.017.428.3.673.708.686c.342.008 1.007-.185 1.02-.6c.008-.292-.416-.596-.429-.858c0-.493.24-.655.643-.673c.308-.012.587.198.913.18a1.38 1.38 0 0 0 1.307-1.32a1.363 1.363 0 0 0-1.389-1.4a1.05 1.05 0 0 0-1.058 1.028c0 .402.377.728.775.711c.288-.009.519-.214.528-.587c-.116.043-.185.073-.245.081c-.077.009-.141-.008-.283-.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32FD2D",
    d: "M14.173 15c.309.013.399-.124.399-.326c0-.073-.013-.159-.026-.244c.626.034.587.18 1.007.3c.129.043.253.085.399.085c.146.013.146.013.287-.017c.291-.062.549-.23.724-.471c.455-.617-.141-.086.155-.484c.158-.227.291-.232.411-.553a.856.856 0 0 0-.797-1.2c-.382.008-.712.3-.72.685c0 .258.15.51.587.51c.064-.505-.094 0-.146-.355c-.017-.103.15-.159.24-.155c.133.005.21.146.206.335c0 .63-.613 1.033-1.114 1.033c-.755 0-1.993-.545-2.07.364c-.017.219.24.484.458.493"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44FEFF",
    d: "M7.599 15.651c-.21-.034-.613-.073-.9-.107c.184.724.48.622.926.99a.83.83 0 0 0 .518.18c.309.009.429-.214.433-.604c-.201.085-.416.171-.591.175c-.197 0-.352-.12-.386-.634"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5FE01",
    d: "M17.658 14.057c.514-.643.75-.643.771-1.072c.03-.715-.459-.287-.06-1.358c-.244.086-.369.201-.489.441c-.205.403-.064.42.06.707c.3.712-.66.523-.287 1.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMv4)",
    d: "M15 15.214c.035.656 1.072.176 1.543.343c-.068.223-.728.497-.745.823c-.018.223.257.42.467.424c.214 0 .45-.09.45-.343c0-.175-.03-.175-.159-.351c.412-.112.574-.292.587-.776c.052-.437.21-.3.24-.711c-.038.094-.283.283-.42.364c-.801.467-1.328 0-1.697.013c-.124.004-.274.073-.266.214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F412",
    d: "M6.395 14.893c.3-.018.244-.06.531.012c.227.052.176.125.386.052c-.15-.244-.039-.223-.253-.407l-1.187-.673c0 .638.236.728.548.818c-.09.112-.068.018-.025.198"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAAE70",
    d: "M8.88 8.186c.146-.283.116-.288.206-.592c.094-.343.219-.437.236-.836c-.557.052-.814.459-.827 1.016c.18.18.253.189.385.412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F48F6D",
    d: "m15.142 6.673l-.043-.137c-.15-.168-.459-.455-.814-.455c-.035.15.158.429.244.613c.223.472.171.06.429.463c.175-.193.171-.201.184-.484"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EFBF8",
    d: "M10.132 14.297c-.034.343.583.06.583.523c.15-.129.205-.257.205-.39c0-.232-.201-.45-.42-.45a.365.365 0 0 0-.368.317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMv5)",
    fillRule: "evenodd",
    d: "M11.036 13.916v.042c.343.665.163.87-.141 1.209c-.112.124-.24.266-.365.454c-.23.379-.353.813-.355 1.256c.017.934.883 1.543 1.748 1.551c.986.013 1.663-.814 1.68-1.727c.013-.835-.458-1.423-1.345-1.423c-.523 0-.909.377-.806.943c.051.313.248.497.54.493c.103 0 .214-.03.334-.069l.009-.685c.647 0 .463 1.015-.412 1.003c-.968 0-.938-1.282-.583-1.856c.339-.54.973-.844 1.873-1.011l.035-.009c.33-.073.518-.429.45-.776a2.14 2.14 0 0 1-2.658.6zm.052 3.278c-.116.009-.275.129-.206.407c.047.184.574.377.626.039c.025-.193-.228-.454-.42-.446",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMv6)",
    d: "m10.016 11.194l-.111.043c-.219.098-.236.103-.42.386c-.103.158-.142.197-.163.24c-.022.055-.017.12-.043.385l-.244-.377a1.3 1.3 0 0 1-.399.274c0 .133.013.228.022.3c.03.223.03.24-.288.472c-.184.129-.227.201-.282.3a3 3 0 0 1-.172.248l-.141.283l-.266-.115a1.2 1.2 0 0 0-.133-.206a1.7 1.7 0 0 1-.214-.343l-.09-.227c-.137-.334-.33-.814-.514-.939c-.283-.192-.322-.128-.369-.042c-.03.047-.06.102-.146.124l-.428-.566c-.043.527-.112 1.389.128 1.8c.324.344.711.621 1.14.819a1.56 1.56 0 0 0-.514-.63l.917.578l.193.189a.7.7 0 0 0 .116.223c.025.034.055.077.107.171c.257.06.351-.03.493-.163l.081-.073l.137-.115c.137-.112.245-.202.343-.378l.043-.107c.129-.317.163-.407.677-.484c.172.232.099.292.112.317c.008.022.06.026.3.073c.214.043.531.052.672-.038l-.004-.035a2.14 2.14 0 0 1-.54-2.387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F92A12",
    d: "M10.192 10.847c.228-.355.556-.636.943-.806l-.043-.064l-.159-.034c-.351-.082-.891-.206-.947.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMv7)",
    d: "M13.38 6.24c.463.051.6.201.725.548c.158.412.18.613.171 1.059c.116.021.313-.249.407-.407l.142.146c.171.977-.335 1.23-.935 1.525l-.12.06c-.222-.017-.304.022-.411.077c-.094.043-.206.103-.459.133c.232-.36.386-.63.386-.9c0-.643-.501-.96-1.093-.977c-.355-.013-.638.202-.874.669a.7.7 0 0 1-.223-.33a.6.6 0 0 0-.163-.266c-.094.711.27 1.243 1.067 1.101c.009-.18-.021-.205-.064-.24c-.043-.034-.09-.077-.128-.291c-.039-.244.287-.429.505-.42c.305.009.54.304.545.686c.012.557-.373.72-.785.891l-.27.12l.215.086c.441.176.87.351 1.487.073c.043.021.06.09.077.145c0 .022.008.039.013.052l.694-.052l.527-.171a1.1 1.1 0 0 1-.141.433l-.047.103c.171.094.205.205.252.385l.013.043l-.227-.056c-.308-.072-.523-.128-.523.116c0 .236.125.322.253.416c.06.043.124.086.176.15c-.283.137-.27.214-.244.399c.012.068.025.154.025.261l-.214.309a2.143 2.143 0 0 0-1.933-2.25c-.308-.172-.686-.198-1.063-.228c-.865-.064-1.714-.128-1.637-1.928l.39.484l.086-.021l-.24-.587c0-.42.18-.892.544-1.158c-.128.03-.304.073-.428.013c.167-.343.411-.458.66-.57l.115-.051c.137-.069.167-.064.185-.077c.021-.009.03-.03.128-.142c.163.043.467.022.759 0a6 6 0 0 1 .407-.03c.291-.008.51.026.707.06c.146.022.279.043.416.043c-.12.142-.275.18-.429.214c-.244.056-.48.112-.544.6c-.043.309.244.622.596.635c.398.008.544-.215.535-.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMv8)",
    fillRule: "evenodd",
    d: "M11.126 11.143c-.411 0-.84.377-.84.827c0 .505.467.891.939.887c.317 0 .6-.231.78-.412c.064.07.424.412.857.412s.861-.463.853-.814c-.017-.549-.33-.9-.9-.9c-.317 0-.583.154-.81.368c-.18-.236-.587-.368-.879-.368m.446.857a.429.429 0 1 1-.858 0a.429.429 0 0 1 .858 0m1.286.428a.429.429 0 1 0 0-.857a.429.429 0 0 0 0 .857",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EFBF8",
    d: "M7.929 15.857a.214.214 0 1 0 0-.429a.214.214 0 0 0 0 .429"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4BFFFF",
    d: "M9.746 16.993c.12.064.232.128.24.265c.017.326-.266.558-.566.549c-.445 0-.852-.296-.848-.724c.004-.802.818-1.277 1.543-1.483c-.249.741-.39.87-.502.968c-.047.043-.094.086-.137.176c.052.124.163.189.27.249m-.531.578a.214.214 0 1 0 0-.428a.214.214 0 0 0 0 .428"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFF71",
    d: "M12.858 6.707a.279.279 0 1 0 0-.557a.279.279 0 0 0 0 .557"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMv0",
    x1: 12,
    x2: 12,
    y1: 4.714,
    y2: 19.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A211E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMv1",
    x1: 12.179,
    x2: 12.179,
    y1: 4.712,
    y2: 19.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A57A70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#350100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02233B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMv2",
    x1: 21.058,
    x2: 11.438,
    y1: 11.344,
    y2: 20.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F96C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFF000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMv3",
    x1: 4.941,
    x2: 21.443,
    y1: 10.728,
    y2: 10.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#72ED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMv4",
    x1: 12.39,
    x2: 12.39,
    y1: 4.712,
    y2: 19.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26F960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMv5",
    x1: 12.309,
    x2: 12.309,
    y1: 4.858,
    y2: 19.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#41FEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMv6",
    x1: 4.268,
    x2: 19.345,
    y1: 9.072,
    y2: 9.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EFB806"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMv7",
    x1: 12.18,
    x2: 16.303,
    y1: 4.715,
    y2: 18.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F5190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F3230C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#CAF301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMv8",
    x1: 4.894,
    x2: 20.375,
    y1: 11.998,
    y2: 11.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E4EBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FF631"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMv);
export default __webpack_public_path__ + "static/media/mv.7e4fcf032730f5f3c5ec99fd3e8daef9.svg";
export { ForwardRef as ReactComponent };